import { GetServerSideProps } from 'next';
import cache from 'memory-cache';
import { getDomainsPaths, resolvePageDataPath } from '@/utils';

import DeliveryPolicy from '@/components/DeliveryPolicy';
import HeadSeo from '@/components/_App/HeadSeo';

import { ADDITIONAL_ROUTES } from '@/data/pages/routes';
import { ListDataInterface } from '@/types/components';

export default function DeliveryPolicyPage({
  data,
}: {
  data: ListDataInterface[];
}) {
  return (
    <div>
      <HeadSeo
        title={ADDITIONAL_ROUTES.deliveryPolicy.title}
        description={ADDITIONAL_ROUTES.deliveryPolicy.description}
      />

      <DeliveryPolicy data={data} />
    </div>
  );
}

export async function getStaticPaths() {
  return {
    paths: await getDomainsPaths(),
    fallback: 'blocking',
  };
}

export async function getStaticProps({
  params: { origin },
}: {
  params: { origin: string };
}) {
  const data = await resolvePageDataPath('deliveryPolicy', origin);

  return {
    revalidate: 3600 * 24 * 30, // set revalidate interval of 30 days
    props: {
      data,
    },
  };
}
